<!--<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{user.ID ? (cyclistView ? ('bikeshop.modal.add_edit_user.edit_cyclist' | translate) : ('bikeshop.modal.add_edit_user.edit_user' | translate)) : (cyclistView ? ('bikeshop.modal.add_edit_user.add_cyclist' | translate) : ('bikeshop.modal.add_edit_user.add_user' | translate))}}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>-->
<div>
  <hub-modal-header headerText="  {{user.ID ? (cyclistView ? ('bikeshop.modal.add_edit_user.edit_cyclist' | translate) : ('bikeshop.modal.add_edit_user.edit_user' | translate)) : (cyclistView ? ('bikeshop.modal.add_edit_user.add_cyclist' | translate) : ('bikeshop.modal.add_edit_user.add_user' | translate))}}"
                    [activeModal]="modal"></hub-modal-header>
</div>

<div class="modal-content-container">

  <div class="tab-container" *ngIf="tabItems.length>1">
    <div class="waiver-tab-container">
      <div class="waiver-tab" *ngFor="let tabs of tabItems; let i = index;"
           [ngClass]="{'selected': checkifActive(tabs)}" (click)="showTabs(tabs)">
        <div>{{tabs.label }}</div>
      </div>

    </div>

    <!--<p-tabMenu [model]="tabItems" [activeItem]="activeItem"></p-tabMenu>-->
  </div>


  <div class="modal-body">
    <div *ngIf="selectedTab===0">
      <app-user [user]="user" [partnerId]="partnerId" [messageService]="messageService" [technicians]="technicians"
                (update)="updateUser($event)" [cyclistView]="cyclistView"></app-user>
    </div>
    <div *ngIf="selectedTab===1">
      <app-technician [user]="user" [users]="users" [partnerId]="partnerId" [messageService]="messageService"
                      (update)="updateUser($event)"></app-technician>
    </div>
    <div *ngIf="selectedTab===2">
      <app-technician-working-hours [user]="user" [partnerId]="partnerId" [messageService]="messageService">
      </app-technician-working-hours>
    </div>
    <div *ngIf="selectedTab===3">

      <app-bikes [cyclist]="user" [singleBike]="singleBike" [bikeId]="bikeId"></app-bikes>
    </div>
    <div *ngIf="selectedTab===4">
      <app-cyclist-bike [partnerId]="partnerId" [user]="user" [messageService]=messageService></app-cyclist-bike>
    </div>
    <div *ngIf="selectedTab===5">
      <app-edit-user [user]="user" [partnerId]="partnerId" [messageService]="messageService"
                (update)="updateUser($event)" [cyclistView]="cyclistView"></app-edit-user>

    </div>
    <div *ngIf="selectedTab===6">
      <app-edit-user-addresses 
        [user]="user" [partnerId]="partnerId" [messageService]="messageService"
        (update)="updateUser($event)" [cyclistView]="cyclistView">
      </app-edit-user-addresses>

    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
